module.exports = __webpack_public_path__ + "static/week_week4_spot1-35dbadc7cfb730725873ceac93400f12.jpg";